import { ImpactCo2AnswerStatsPublic } from '@/domain/impact-stats/entities/stats-public.entity';
import { createAppAsyncThunk } from '@/domain/store.thunk';

import { selectExternalInvitationSurveys } from '../external-invitation-survey.selectors';

type Params = void;

type Result = Record<number, ImpactCo2AnswerStatsPublic>;

export const getSurveysResults = createAppAsyncThunk(
  'externalInvitationSurvey/getSurveysResults',
  async (
    _params: Params,
    { getState, extra: { impactStatsGateway } },
  ): Promise<Result> => {
    const surveys = selectExternalInvitationSurveys(getState());
    const results = await Promise.all(
      surveys.map(async (survey) => {
        const result = await impactStatsGateway.getStatsPublic(
          survey.projectId,
          survey.code,
        );
        return [survey.id, result];
      }),
    );
    return Object.fromEntries(results);
  },
);
